export const NON_NUMBER_REGEX = /\D/g;

export const WHITESPACE_REGEX = /\s/g;